import { call, put, takeLatest } from 'typed-redux-saga'
import { productsApi, productsSlice, ProductsNS } from 'Pages/registratorCabinet'
import { ResponseCatalog, ProductRecommendationModel } from 'Models'
import { errorHandler, loadersSlice } from 'Modules'
import { Deserialize } from 'cerialize'
import { ProductModel } from 'Pages/orders'

function* getRecommendations(action: ProductsNS.getRecommendations) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(productsApi.getRecommendations, action.payload)
		const recommendations = new ResponseCatalog<ProductRecommendationModel>(res)
		yield* put(productsSlice.actions.setRecommendations(recommendations))
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

function* getProducts(action: ProductsNS.getProducts) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(productsApi.getProducts, action.payload)
		const entries = res.entries.map((product): ProductModel[] => Deserialize(product, ProductModel))
		const products = Deserialize(res, ResponseCatalog)
		products.entries = entries
		yield* put(productsSlice.actions.setProducts(products))
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

export function* productsSaga() {
	yield* takeLatest(productsSlice.actions.getRecommendations.type, getRecommendations)
	yield* takeLatest(productsSlice.actions.getProducts.type, getProducts)
}
